import { Injectable } from '@angular/core';
import { PageService } from './page.service';
import { ArcService } from './arc.service';
import { RuntimeService } from './runtime.service';
import { UtilsService } from './utils.service';

@Injectable()
export class SeedService {
  private _projects = {
    dehet: {
      id: 'dehet',
      app: 'Rating',
      title: 'DEHET'
    },
    glykoalkaloids: {
      id: 'glykoalkaloids',
      app: 'Rating',
      title: 'GLYKOALKALOIDS'
    },
    quinoalkaloids: {
      id: 'quinoalkaloids',
      app: 'Rating',
      title: 'QUINOALKALOIDS'
    },
    nanopigs: {
      id: 'nanopigs',
      app: 'Rating',
      title: 'NANOPIGS'
    },
    nanopigs2: {
      id: 'nanopigs2',
      app: 'Rating',
      title: 'NANOPIGS-2'
    },
    'nanopigs-3': {
      id: 'nanopigs-3',
      app: 'Rating',
      title: 'NANOPIGS 3'
    },
    'pndt': {
      id: 'pndt',
      app: 'Rating',
      title: 'ECHA PNDT GI Tox'
    },
    'pndt_exp1': {
      id: 'pndt_exp1',
      app: 'Rating',
      title: 'ECHA PNDT - EXP1'
    },
    'pndt_exp2': {
      id: 'pndt_exp2',
      app: 'Rating',
      title: 'ECHA PNDT - EXP 2'
    },
    'pndt_rab2006': {
      id: 'pndt_rab2006',
      app: 'Rating',
      title: 'ECHA PNDT GI Tox - Rabbits - pre-2006'
    },
    'pndt_rats': {
      id: 'pndt_rats',
      app: 'Rating',
      title: 'ECHA PNDT GI Tox - Rats'
    },
    'jrc-respiratory': {
      id: 'jrc-respiratory',
      app: 'Rating',
      title: 'JRC Respiratory'
    },
    'jrc-noncancer': {
      id: 'jrc-noncancer',
      app: 'Rating',
      title: 'JRC Respiratory Diseases - non-cancer'
    },
    'tmp': {
      id: 'tmp',
      app: 'Rating',
      title: 'TMP'
    }
  };

  constructor(
    private pgs: PageService,
    private arcs: ArcService,
    private rts: RuntimeService,
    private utils: UtilsService
  ) { }

  upload(seed, payload) {
    let obs = this.arcs.run(
      {
        fun: 'seedUpload',
        seed: seed,
        records: payload
      });
    obs.subscribe((resp) => {
      console.log(4889, resp);
    });
  }

  run(seedId: string, fn: string) {
    let ls = [];
    this.pgs.lastRecords.forEach((x) => ls.push(x.seed()));
    if (!ls.length)
      return;
    let seed = this._projects[seedId];
    seed['fn'] = fn;
    if (seedId === 'quinoalkaloids' ||
      seedId === 'pndt_rats' ||
      seedId === 'jrc-noncancer') {
      this.utils.saveExport(ls, seedId + '.json');
      return;
    }
    this.upload(seed, ls);
  }

  runSupport(seedId: string) {
    let tags = [];
    this.rts.currentProject.tagsMap.forEach(x => {
      tags.push(x.seed);
    });
    let criterions = [];
    this.rts.currentProject.criterionsMap.forEach(x => {
      criterions.push(x.seed);
    });
    let seed = this._projects[seedId];
    seed['fn'] = '_supportData';
    this.upload(seed, { tags: tags, criterions: criterions });
  }

  get projectsLs() {
    let ls = [];
    Object.keys(this._projects).forEach((k) => ls.push(this._projects[k]));
    ls.sort((a, b) =>
      a['title'].toLowerCase() < b['title'].toLowerCase() ? -1 : 1);
    return ls;
  }


}



// WEBPACK FOOTER //
// ./src/app/seed.service.ts